/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectOptionsResource
 */
export interface ProjectOptionsResource {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectOptionsResource
     */
    canCloseProject: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectOptionsResource
     */
    canBeRenewed: boolean;
}

/**
 * Check if a given object implements the ProjectOptionsResource interface.
 */
export function instanceOfProjectOptionsResource(value: object): value is ProjectOptionsResource {
    if (!('canCloseProject' in value) || value['canCloseProject'] === undefined) return false;
    if (!('canBeRenewed' in value) || value['canBeRenewed'] === undefined) return false;
    return true;
}

export function ProjectOptionsResourceFromJSON(json: any): ProjectOptionsResource {
    return ProjectOptionsResourceFromJSONTyped(json, false);
}

export function ProjectOptionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectOptionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'canCloseProject': json['canCloseProject'],
        'canBeRenewed': json['canBeRenewed'],
    };
}

export function ProjectOptionsResourceToJSON(value?: ProjectOptionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canCloseProject': value['canCloseProject'],
        'canBeRenewed': value['canBeRenewed'],
    };
}

